
$(document).ready(function () {
	// register gsap
	gsap.registerPlugin(ScrollTrigger);

    var w = $(window).width()

	// refresh scroll position
    let lastHeight = document.body.scrollHeight;
	setInterval(() => {
	  const newHeight = document.body.scrollHeight;
	  if (newHeight !== lastHeight) {
	    lastHeight = newHeight;
	    ScrollTrigger.refresh();
	  }
	}, 300);

	// smooth scroll
	window.lenis = new Lenis({ smoothWheel: true, duration: 2, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), })
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf)

    // capsule lottie play
    const lottieAnim = lottie.loadAnimation({
        container: w < 991
		  	? document.querySelector('.capsule-lottie-is-mobile')
		  	: document.querySelector('.capsule-lottie'),
        renderer: "svg",
        loop: false,
        autoplay: false,
        path: 'https://raw.githubusercontent.com/janakmark91-alt/Assets/refs/heads/main/Beautywise/capsule.mp4.lottie.json'
    });

    lottieAnim.addEventListener("DOMLoaded", function () {
        const totalFrames = lottieAnim.totalFrames;
        let playhead = { frame: 0 };

        gsap.to(playhead, {
            frame: totalFrames - 1,
            ease: "none",
            scrollTrigger: {
                trigger: ".section_capsule",
                start: "top 0%",
                end: () => {
				    const el = document.querySelector('.section_capsules');
				    if (!el) return "bottom 100%";

				    return w < 991 
				        ? "+=" + (el.offsetHeight + 800)
				        : "bottom 100%";
				},
				pinSpacing: true,
                scrub: true
            },
            onUpdate: function () { lottieAnim.goToAndStop(Math.round(playhead.frame), true) }
        });
    });

    // // result scroll
    // let time1 = false;
    // let time2 = false;
    // const rtl = gsap.timeline({
    //   	scrollTrigger: {
    //     	trigger: ".section_result",
    //     	start: "top top",
    //     	end: "+=200%",
    //     	scrub: true,
    //     	onUpdate: self => {
    //       		const p = self.progress;

    //       		// Play - day 30
	// 		   	if (p > 0.2 && self.direction === 1 && !time1) {
	// 		   	  	time1 = true;
	// 		   	  	$('.result-progress-card, .result-img, .result-content-card').removeClass('is-active')
	// 		   	  	$('.result-progress-card.is-2, .result-img.is-2, .result-content-card.is-2').addClass('is-active')
	// 		   	  	$('.result-progress-card.is-1').addClass('is-dot-active')
	// 		   	}

	// 		   	// Reverse - day 30
	// 		   	if (p < 0.2 && self.direction === -1 && time1) {
	// 		   	  	time1 = false;
	// 		   	  	$('.result-progress-card, .result-img, .result-content-card').removeClass('is-active')
	// 		   	  	$('.result-progress-card.is-1, .result-img.is-1, .result-content-card.is-1').addClass('is-active')
	// 		   	  	$('.result-progress-card.is-1').removeClass('is-dot-active')
	// 		   	}

    //       		// Play - day 90
	// 		   	if (p > 0.4 && self.direction === 1 && !time2) {
	// 		   	  	time2 = true;
	// 		   	  	$('.result-progress-card, .result-img, .result-content-card').removeClass('is-active')
	// 		   	  	$('.result-progress-card.is-3, .result-img.is-3, .result-content-card.is-3').addClass('is-active')
	// 		   	  	$('.result-progress-card.is-2').addClass('is-dot-active')
	// 		   	}

	// 		   	// Reverse - day 90
	// 		   	if (p < 0.4 && self.direction === -1 && time2) {
	// 		   	  	time2 = false;
	// 		   	  	$('.result-progress-card, .result-img, .result-content-card').removeClass('is-active')
	// 		   	  	$('.result-progress-card.is-2, .result-img.is-2, .result-content-card.is-2').addClass('is-active')
	// 		   	  	$('.result-progress-card.is-2').removeClass('is-dot-active')
	// 		   	}
    //     	}
    //   	}
    // })
    // if(w > 991) {
	//     rtl.to('.result-progress-bar', { height: '100%' })
	//     .to('.result-ball', { translateY: $('.result-progress-block').height() }, '<')
	// }
	// else {
	// 	gsap.timeline({
	// 		scrollTrigger: {
	//         	trigger: ".section_result",
	//         	start: "top top",
	//         	end: w < 768 ? "+=120%" : "+=160%",
	//         	scrub: true,
	//         }
	// 	})
	//     .to('.result-progress-bar', { width: '100%' })
	//     .to('.result-ball', { translateX: ($('.result-progress-block').width() - 20) }, '<')
	// }

    // myth - truth


const news_swiper = new Swiper('.myth-truth-block', {
	   		wrapperClass: 'myth-truth-relative',
	   		slideClass: 'myth-truth-card',
	   		slidesPerView: '5',
	   		spaceBetween: 16,
		    loop: false,
		    freeMode: false,
		    slidesPerGroup: 1,
		    centeredSlides: false,
			breakpoints: {
				0: {              
					slidesPerView: 1.3,
					spaceBetween: 12,
				},
				480: {            // Mobile Landscape
					slidesPerView: 2,
					spaceBetween: 12,
				},
				768: {            // Tablet
					slidesPerView: 3,
					spaceBetween: 14,
				},
				1024: {           // Small Desktop
					slidesPerView: 4,
					spaceBetween: 16,
				},
				1560: {           // Large Desktop
					slidesPerView: 5.5,
					spaceBetween: 16,
				}
    		}
	    });	



const cards = document.querySelectorAll('.myth-truth-card');

cards.forEach(card => {
    card.addEventListener('click', () => {

        const img = card.querySelector(".roundimage");

        // Case 1: If card already active → deactivate, BUT don't flip image again
        if (card.classList.contains('active')) {
            card.classList.remove('active');
            img.classList.remove("img-active"); // stop flip
            return;
        }

        // Case 2: Activate card → remove active from others
        cards.forEach(c => {
            c.classList.remove('active');
            c.querySelector('.roundimage').classList.remove("img-active");
        });

        card.classList.add('active');
        img.classList.add("img-active"); // flip ONCE
    });
});





    // if(w > 991) {
	//     const myth_truth_tl = gsap.timeline({
	//       	scrollTrigger: {
	//         	trigger: ".section_myth_truth",
	//         	start: "top top",
	//         	end: "bottom bottom",
	//         	scrub: true,
	//       	}
	//     })
	//     .to('.myth-truth-card.is-1', { translateX: '-28rem', translateY: '-9rem' })
	// 	.to('.myth-truth-card.is-2', { translateX: '-17rem', translateY: '-5rem' }, '<')
	// 	.to('.myth-truth-card.is-3', { translateX: '-6rem', translateY: '-2rem' }, '<')
	// 	.to('.myth-truth-card.is-4', { translateX: '6rem', translateY: '2rem' }, '<')
	// 	.to('.myth-truth-card.is-5', { translateX: '17rem', translateY: '5rem' }, '<')
	// 	.to('.myth-truth-card.is-6', { translateX: '28rem', translateY: '9rem' }, '<')

	// 	// second scroll
	// 	.to('.myth-truth-card.is-2', { translateX: '24rem', translateY: '5rem' })
	// 	.to('.myth-truth-card.is-3', { translateX: '25rem', translateY: '6rem' }, '<')
	// 	.to('.myth-truth-card.is-4', { translateX: '26rem', translateY: '7rem'  }, '<')
	// 	.to('.myth-truth-card.is-5', { translateX: '27rem', translateY: '8rem'  }, '<')
	// 	.to('.myth-truth-card.is-6', { translateX: '28rem', translateY: '9rem'  }, '<')

	// 	// flip card 1
	// 	.to('.myth-truth-card.is-1', { rotateY: '-180deg' })

	// 	// ---- 2 ---- //
	// 	// middle
	// 	.to('.myth-truth-card.is-2', { translateX: '-1.5rem', translateY: '-2rem' })
	// 	// flip
	// 	.to('.myth-truth-card.is-2', { rotateY: '-180deg' })
	// 	// left
	// 	.to('.myth-truth-card.is-2', { translateX: '-27rem', translateY: '-8rem' })

	// 	// ---- 3 ---- //
	// 	// middle
	// 	.to('.myth-truth-card.is-3', { translateX: '-0.5rem', translateY: '-2rem' })
	// 	// flip
	// 	.to('.myth-truth-card.is-3', { rotateY: '-180deg' })
	// 	// left
	// 	.to('.myth-truth-card.is-3', { translateX: '-26rem', translateY: '-7rem' })

	// 	// ---- 4 ---- //
	// 	// middle
	// 	.to('.myth-truth-card.is-4', { translateX: '0.5rem', translateY: '-2rem' })
	// 	// flip
	// 	.to('.myth-truth-card.is-4', { rotateY: '-180deg' })
	// 	// left
	// 	.to('.myth-truth-card.is-4', { translateX: '-25rem', translateY: '-6rem' })

	// 	// ---- 5 ---- //
	// 	// middle
	// 	.to('.myth-truth-card.is-5', { translateX: '1.5rem', translateY: '-2rem' })
	// 	// flip
	// 	.to('.myth-truth-card.is-5', { rotateY: '-180deg' })
	// 	// left
	// 	.to('.myth-truth-card.is-5', { translateX: '-24rem', translateY: '-5rem' })

	// 	// ---- 6 ---- //
	// 	// middle
	// 	.to('.myth-truth-card.is-6', { translateX: '2rem', translateY: '2rem' })
	// 	// flip
	// 	.to('.myth-truth-card.is-6', { rotateY: '-180deg' })
	// }
	// else {
	// 	const news_swiper = new Swiper('.myth-truth-block', {
	//    		wrapperClass: 'myth-truth-relative',
	//    		slideClass: 'myth-truth-card',
	//    		slidesPerView: 'auto',
	//    		spaceBetween: 16,
	// 	    loop: false,
	// 	    freeMode: false,
	// 	    slidesPerGroup: 1,
	// 	    centeredSlides: false
	//     });	
	// }
})


$(document).ready(function () {
	// register gsap
	gsap.registerPlugin(ScrollTrigger, Observer);

    var w = $(window).width()

	// refresh scroll position
    let lastHeight = document.body.scrollHeight;
	setInterval(() => {
	  const newHeight = document.body.scrollHeight;
	  if (newHeight !== lastHeight) {
	    lastHeight = newHeight;
	    ScrollTrigger.refresh();
	  }
	}, 300);

    // result scroll
    ScrollTrigger.create({
		trigger: '.section_result',
		start: '+=20% top',
	    onEnter: () => {
	    	// current active
	    	$('.result-content-card, .result-progress-card, .result-img').removeClass('is-active')
	    	$('.result-content-card.is-2, .result-progress-card.is-2, .result-img.is-2').addClass('is-active')

	    	// prev active
	    	$('.result-progress-card').removeClass('is-prev-active')
	    	$('.result-progress-card.is-1').addClass('is-prev-active')

	    	// progress line
	    	$('.result-progress-bar, .result-ball').removeClass('is-1 is-2 is-3')
	    	$('.result-progress-bar, .result-ball').addClass('is-2')
		},
	    onLeaveBack: () => {
	    	// current active
	    	$('.result-content-card, .result-progress-card, .result-img').removeClass('is-active')
	    	$('.result-content-card.is-1, .result-progress-card.is-1, .result-img.is-1').addClass('is-active')

	    	// prev active
	    	$('.result-progress-card').removeClass('is-prev-active')

	    	// progress line
	    	$('.result-progress-bar, .result-ball').removeClass('is-1 is-2 is-3')
	    	$('.result-progress-bar, .result-ball').addClass('is-1')
	    },
	});

    ScrollTrigger.create({
		trigger: '.section_result',
		start: '+=50% top',
	    onEnter: () => {
	    	// current active
	    	$('.result-content-card, .result-progress-card, .result-img').removeClass('is-active')
	    	$('.result-content-card.is-3, .result-progress-card.is-3, .result-img.is-3').addClass('is-active')

	    	// prev active
	    	$('.result-progress-card').removeClass('is-prev-active')
	    	$('.result-progress-card.is-2, .result-progress-card.is-1').addClass('is-prev-active')

	    	// progress line
	    	$('.result-progress-bar, .result-ball').removeClass('is-1 is-2 is-3')
	    	$('.result-progress-bar, .result-ball').addClass('is-3')
		},
	    onLeaveBack: () => {
	    	// current active
	    	$('.result-content-card, .result-progress-card, .result-img').removeClass('is-active')
	    	$('.result-content-card.is-2, .result-progress-card.is-2, .result-img.is-2').addClass('is-active')

	    	// prev active
	    	$('.result-progress-card').removeClass('is-prev-active')
	    	$('.result-progress-card.is-1').addClass('is-prev-active')

	    	// progress line
	    	$('.result-progress-bar, .result-ball').removeClass('is-1 is-2 is-3')
	    	$('.result-progress-bar, .result-ball').addClass('is-2')
	    },
	});
})